// ─────────────────────────────────────────────────────────────
// EmailJS Configuration
// Sign up / log in at https://www.emailjs.com/
// Then replace the three values below with your own credentials.
// ─────────────────────────────────────────────────────────────

export const EMAILJS = {
    serviceId:  'YOUR_SERVICE_ID',   // e.g. 'service_abc123'
    templateId: 'YOUR_TEMPLATE_ID',  // e.g. 'template_xyz789'
    publicKey:  'YOUR_PUBLIC_KEY',   // e.g. 'AbCdEfGhIjKlMnOp'
};
